<template>
	<div class="CallCenter"
		v-loading.fullscreen.lock="$GVO.fullscreenLoading"
		element-loading-text="Загрузка данных..."
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)"	>
		<div class="filter-tag-row">
			<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Лидов: {{this.masObjects_total}}</span>
		</div>	
		<div class="d-flex flex-wrap" v-if="this.massTags.length > 0">
			<span v-for="tag in this.massTags" :key="tag.param_id" class="el-tag el-tag--small el-tag el-tag--plain el-tag--primary">
				<span>{{tag.name}}</span><span v-if="tag.val!='' && !tag.descr">: {{ tag.val }}</span><span v-if="tag.descr && tag.descr!=''">: {{ tag.descr }}</span>
				<!-- <span>{{tag.name}}</span><span v-if="tag.val!=''">: {{ tag.val }}</span> -->
			</span>
			
		</div>	
		<div class="col-lg-8" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			v-on:PushTags="PushTags"
			:tags="true"
			name="callcenter"/>
		</div>

		<base-button
			@click="SelectStation()"
			v-if="!hideCCphone"			
			:class="[(selectedStation == 'Не выбрана') ? 'btn-danger' : 'btn-success']"
			class="mr-2"
		>Станция: {{ selectedStation }}</base-button>
		<base-button
			@click="ClearStation()"
			v-if="!hideCCphone"
			class="btn-primary btn-simple mr-2"
		>Сменить станцию</base-button>

		<base-button   
		v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.OperatorCC == 1 "
		@click="AddLead2()" 
		class="btn-simple btn-success" 
		>Создать лид</base-button>	

		<div class="row mx-0" v-if="false /*this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.OperatorCC == 1*/">
			<base-button   
				@click="AddLead2()" 
				class="btn-simple btn-success" 
				style="height: 40px; align-self: flex-end; margin-bottom: 19px;"
			>Создать лид</base-button>	
			<ReInputContact 
				class="ml-3"
				v-model="pre_phone" 
				:contactGroup_options="arrCG_opt" 
				contactGroup="phone"
				label="Контакт для предзаполнения"
				:delMethod="ci_del"
				:required="false"
				:bShowView="false"
				:bShowCallBtn="true"
				:isCallCenter="true"
				:saveClientFio="true"
				:bShowAddBtn="false"
				:bCheckClient="false"
			/>
		</div>

		<div v-if="selectStation" class="row mx-0">
			<base-button
				v-for="item in stationList"
				@click="setStation(item.id)"
				simple
				class="btn-primary mr-2"
				:key="item.id"
			>{{ item.name }}</base-button>

		</div>

		<div class="my-2" v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.code == 3675">
			
			<ReReportForm
				:objGetParams="objGetParams"
				obj="LEAD"
				:strTags="this.strTags"
				:tags="this.massTags"
			/>

<!--
			<template v-if="this.reportAttributes != '' && !this.$GVO.isEmpty(this.objReport)">
				<ReReports module="LEAD" :flt="objGetParams" :keyParam="reportAttributes" :tags="this.massTags" :strTags="this.strTags" :objReport="objReport" />
			</template>
-->
		</div>

		<div v-if="ApiCallCenter" class="my-3">
			<ReLeadSearchCard v-for="lead in ApiCallCenter" :ApiData="lead" :key="lead.id" />
		</div>
		
		<h3 class="text-center my-3" v-if="ApiCallCenter.length==0">Ничего не найдено</h3>	

		<Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(10)" 
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>

		<!-- <div v-if="bIsEdit && ApiCallCenter.length>0">
			<div class="clientPage bntGroup">
				<base-button @click="GoToEdit(false)" type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
			</div>
			<LeadEdit :objLead="ApiCallCenter[0]" />
		</div> -->

	</div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn, Select, Option, Tooltip, Button } from 'element-ui';
// import { TabPane, Tabs, Collapse, CollapseItem  } from 'src/components';
// import ReInputSearchDropType from 'src/our_modules/SearchSendObjects/ReInputSearchDropType.vue';
// import ReInputRange from "src/our_components/ReInputRange.vue";
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReHouseClassMap from 'src/our_components/ReHouseClassMap.vue';
import Pagination from 'src/our_components/RePagination';
import ReLeadSearchCard from 'src/our_components/ReLeadSearchCard.vue';
// import { Card } from "../components";
// import ReReports from 'src/our_components/ReReports.vue';
import ReReportForm from 'src/our_components/ReReportForm.vue';
import ReInputContact from "src/our_components/ReInputContact.vue";

// import LeadEdit from  'src/our_pages/LeadEdit.vue';


export default {
	name: 'callcenter-page',
	components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    // TabPane,
    // Tabs,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    // ReInputSearchDropType,
    // ReInputRange,
    ReFilterBtn,
    ReFilter,
    // ReHouseClassMap,
    Pagination,
    // Card,
	// Collapse,
	// CollapseItem,
	ReLeadSearchCard,
	// ReReports,
	ReReportForm,
	// LeadEdit,
	ReInputContact,
},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			// currentApiFormMethod: this.currentApiFormMethodComp(),
			// masAllFormParams: this.currentFormConfig(),
			masObjects_total: 0,
			count2page: 10,
			objGetParams: {},
			objSortLoc: {order_field: 'dwl_date', sortOrder: 'descending'}, //ascending
			fullscreenLoading: false,
			strAudioLink: '',
			objCall: {},
			expandRowKeys: [],
			clientCallNum: '',
			rowTypeName: '',
			adsSourceExtendMap: [],
			// adsSourceExtendMap: [],
			ApiCallCenter: [],
			bIsEdit: false,
			selectStation: false, // Форма выбора телефонной станции
			selectedStation: 'Не выбрана',
			stationList: [],
			hideCCphone: true,
			massTags: [],
			strTags: '',
			pre_phone:[{
				'contact_id':'',
				'contact_type':'1',
				'contact_value':'',
				'contact_view':'',
				'contact_group':'phone'
			}],
			arrCG_opt:[{'value':'1','label':'Телефон моб.'},{'value':'2','label':'Телефон раб.'}],
			ci_del:{'apiMethod':'DEL_CONTACT','apiParam':{'obj':'client','flt':{'id':'','contact_id':''}}},
		};
	},
	watch: {
		$route(to, from) {
			if(location.pathname.indexOf('/data/callcenter/add') != -1){
			// if(location.pathname.indexOf('/data/callcenter/add?srv_new=1&srv_inwork=1') != -1){
				this.bIsEdit = true;
			}else{
				if(location.pathname.indexOf('/edit') != -1){
					this.bIsEdit = true;
				}else{
					this.bIsEdit = false;
				}
			}
			// let fromRoot = from.fullPath;
			// 		let toRoot = to.fullPath;
			// 		console.log('fromRoot', fromRoot);
			// 		console.log('toRoot', toRoot);
			//this.getClient();
		}
	},
	methods: {
		getCallCenterData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			let sortOrder = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getCallCenterData',this.objGetParams);
				filter = this.objGetParams;
			} 
			// if (!this.$GVO.isEmpty(this.objSortLoc)) {
			// 	sortOrder = {'order_field':`${this.objSortLoc.order_field} ${this.objSortLoc.sortOrder==='descending'?'desc':'asc'}`}
			// }

			this.$GVO.ApiCall('LEAD.GET',{flt:{...filter,...sortOrder, act:1, }}) // 'list':true,
				.then((objApi) => {
					// console.log(objApi);
					this.ApiCallCenter = [];
					this.masObjects_total = 0;

					if(objApi.success){
						
						this.ApiCallCenter = objApi.data;
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }

					} else {
						this.ApiCallCenter = [];
						this.masObjects_total=0;
					}
				})
				.catch(errorObjApi => {this.ApiCallCenter = []; this.masObjects_total=0; console.error(errorObjApi);});
		},



		tableRowClassName({row, rowIndex}) {
			if(row.RecID == '') {
				// console.log(objApi);
				return 'row-expand-cover';
			} else {
				return 'row-expand-hover';
			}
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('LEAD.GET_FILTER',{})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					// this.masAllFilterParams = objApi.config;
					this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
					eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		// AddLead(CallFlow, CallerIDNum, CalledNumber){			
		// 	if(CallFlow == 'in') {this.clientCallNum = CallerIDNum;} else {this.clientCallNum = CalledNumber;}
		// 	// console.log('This clientCallNum is ' + this.clientCallNum);
		// 	this.clientCallNum = this.clientCallNum.replace(/\+/, '');
		// 	this.$router.push({path: `/data/callcenter/add?contact_value=${this.clientCallNum}`});		
		// 	// /data/callcenter/id/:client_id/edit
		// },
		AddLead2(){			
			// this.$router.push({path: `/data/callcenter/add?contact_value=${clientCallNum}`});
			let phone = '';
			phone = this.pre_phone[0].contact_value;
			let strCheckPhone = '';
			if(phone != '') strCheckPhone = `?chkPhone=${phone}`;

			this.$router.push({path: `/data/callcenter/add${strCheckPhone}`});
			// this.$router.push({path: `/data/callcenter/add?srv_new=1&srv_inwork=1`});		
		},
		
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		
		OnFilterApply(data){
			//console.log('OnFilterApply_data',data);
			//console.log('OnFilterApply_get',this.$GVO.unlinkObject(this.objGetParams));

			this.bShowFilter=false;
			
			let bFromObj = false;
			if(SGVO.prevRoute != null) 
				if(SGVO.prevRoute.indexOf('/callcenter/id/')>0) bFromObj = true;

			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined' && bFromObj==false){
				delete this.objGetParams['p'];
			}
			SGVO.prevRoute=null;		

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getCallCenterData();
			
		},
		onSortChange(objSort){
			//console.log(objSort);
			this.$emit('sort', objSort);
			this.objSortLoc.order_field = this.$GVO.unlinkObject(objSort.prop);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(objSort.order);
			if(objSort.order != null){
				var queryParams = new URLSearchParams(window.location.search);
				queryParams.set("order_field", objSort.prop);
				queryParams.set("sortOrder", objSort.order);
				history.replaceState(null, null, "?"+queryParams.toString());
				this.objGetParams = this.$GVO.GetAllGet();
				this.OnFilterApply();
			}
		},
		SuccessGo(evt,dopParam){
			// console.log(evt,dopParam);
			//тут надо написать опустошитель формы
		},	
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 3000);
		},
		GoToEdit(bGoEdit=true){
			//this.bIsEdit = bGo;
			if(bGoEdit){
				this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id+'/edit'});
			}else{
				if(location.pathname.indexOf('/data/callcenter/add') != -1){
					this.$router.push({path: '/data/callcenter'});
				}else{
					this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id});
				}
			}
		},
		GoToObj(rowData){
			this.$router.push({path: `/data/callcenter/id/${rowData.id}`});
		},
		openLeadPage(rowData){
			this.$router.push({path: `/data/callcenter/id/${rowData.id}`});
		},
		SelectStation(first){
			if(this.stationList.length == 0){
				this.$GVO.ApiCall('PHONE_STATION_GET',{obj:'LEAD', flt:{}}).then(result=>{
					if(result.success){
						if(result.data.noCC){
							this.hideCCphone = true
						}else{
							this.hideCCphone = false
						}
						if(result.data.data)
							this.stationList = result.data.data
						if(result.data.phone){
							let phone = result.data.phone
							let found = this.stationList.find(line=>line.phone==phone)

							if(found){
								this.selectedStation = found.name
							}else{
								this.selectStation = true
							}
						}else{
							this.selectStation = true
						}
					}
				})
			}
			if(!first){
				this.selectStation = true
			}
		},
		setStation(id){
			this.$GVO.ApiCall('PHONE_STATION_SET',{obj:'LEAD', flt:{id}}).then(result=>{
				if(result.success){
					this.selectStation = false;
					this.selectedStation = result.data.name;
				}
			})
		},
		ClearStation(){
			this.selectStation = true;
			this.selectedStation = 'Не выбрана';
		},
		
		PushTags(data){
			this.massTags = data;

			let smtharray = [];
			if(this.massTags.length > 0){
				for (let i = 0;  i < this.massTags.length; i++) {
					if(this.massTags[i].param_id!='work_time' && this.massTags[i].param_id!='JSON_structure'){ 
						smtharray.push(`${this.massTags[i].name} : ${this.massTags[i].val}`);
					}else if (this.massTags[i].param_id=='work_time' && this.massTags[i].val == 1){
						smtharray.push(`${this.massTags[i].name} : Да`);
					}else if (this.massTags[i].param_id=='work_time' && this.massTags[i].val == 0){
						//кажется в фильтре в теге не пишется ничего, если его val 0
						smtharray.push(`${this.massTags[i].name} : Нет`);
					}
					if (this.massTags[i].param_id=='JSON_structure' ){
						// console.log('this.massTags JSON_structure', this.massTags[i].descr);
						smtharray.push(`${this.massTags[i].name} : ${this.massTags[i].descr} `);
					}
				}
			}
			this.strTags = smtharray.join('; ');
			// console.log('this.massTags', this.massTags );
		}

	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		// // console.log(this.objGetParams);
		if(typeof this.objGetParams.order_field != 'undefined'){
			this.objSortLoc.order_field = this.$GVO.unlinkObject(this.objGetParams.order_field);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(this.objGetParams.sortOrder);
			this.$refs.tableData.sort(this.objSortLoc.prop,this.objSortLoc.order);
		}
		// this.getCallCenterData();

		this.SelectStation(true);
	},
	created() {
		// eventEmitter.$on('ResetFilter', this.ResetDopFilter);
				
	}
};
</script>

<style scoped>

.CallCenter >>>  .cellmap-wrapper, .CallCenter >>>  .map {
	width: 100%;	
	height: 100%;
}
.CallCenter >>>  .cellmap {
	width: 100%;
	height: 100%;
	background: rgba(16, 33, 63, 0.986);
}
.CallCenter >>>  .post {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
	position: sticky;
	bottom: 0;		
}
.CallCenter .post >>> .card-body {padding: 0px 5px 15px 10px!important;}
.CallCenter >>>  .majorFilter-card {border: 1px solid #01b0e0;}
.CallCenter >>>  .majorFilter {display: flex; }
.CallCenter >>>  .firstFilter-row {display: flex; flex-wrap: wrap; width: 100%;}
.filter-shown {display: block;}
.filter-hidden {display: none;}
.CallCenter >>>  .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.CallCenter >>>  .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.CallCenter >>>  .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.CallCenter >>>  .form-group {
	margin-bottom: 0px!important;
}
.CallFlow {
	display: inline-block;
	width: 25px;
	height: 25px;
	
}
.CallFlowIn {
	background: url('/img/icons/inCall.svg') no-repeat 50% 50%;
	background-size: contain;
}
.CallFlowOut {
	background: url('/img/icons/outCall.svg') no-repeat 50% 50%;
	background-size: contain;
}
.CallCenter >>>  .el-table .cell   {
	word-break: break-word;
}
.CallCenter >>>  .el-table .cell span {
	display:inline-flex;
	word-break: break-word;
}
/* .CallCenter .row-expand-hover:hover {cursor:pointer;}
.CallCenter .row-expand-cover .el-table__expand-icon{visibility:hidden;}
.CallCenter .el-table__expand-icon {
    color: #00BF9A !important;
	font-size: 14px;
} */
.CallCenter >>> .el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);}
.white-content .card:not(.card-white) >>> label {
		color: #1d253b!important;
	}
</style>
